import localforage from "localforage";

/* 🔹 MASTER DATA (registration) */
export const registrationDB = localforage.createInstance({
  name: "canteen-app",
  storeName: "registrations",
});

/* 🔹 SCAN QUEUE */
export const scanDB = localforage.createInstance({
  name: "canteen-app",
  storeName: "scan_queue",
});
